import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from '@sentry/angular';
import { APP_VERSION } from './version';
const hostname = window.location.hostname;
const isIgnoredDomain = hostname.includes('dev.list.ash-tom.love');

Sentry.init({
  enabled: !isIgnoredDomain,
  dsn: 'https://d7afd9c5bb5b6975ef6468b64a8a2e50@o4511296266633216.ingest.de.sentry.io/4511348187594832',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/list\.ash-tom\.love\//, /^https:\/\/ash-tom\.love\//],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable sending logs to Sentry
  enableLogs: true,
  release: `einkaufsliste@${APP_VERSION}`,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
